// import "../auth/login.css";
import FrontendLayout from "../../layouts/FrontendLayout";
import Helmet from "../../components/Helmet";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

import api from "../../api/axiosInstance";
import Header from "../../components/FrontendHeader";
import Admin from "./Admin";
import { jwtDecode } from "jwt-decode";

export default function FreshViewData() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(true);
  const [previewData, setPreviewData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [bankData, setBankData] = useState({
    STUDENT_BANK_ACC: "",
    BANK_IFSC_CODE: "",
    STUDENT_BANK_NAME: "",
  });
  const adminStatusMessage = {
    APPROVED: "This application has been approved. No further action is required.",
    VERIFIED: "This application has been verified. Please review the documents and take the final approval decision.",
    DISCREPANCY: "This application has been marked for discrepancy.",
    REJECTED: "This application has been rejected. Please review the rejection remarks, if any.",
    PENDING: "This application is awaiting verification. Please verify the submitted documents and update the status accordingly."
  };
  const token = localStorage.getItem("token");
  const adminRole = jwtDecode(token).role;
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    status: "",
    remarks: "",
    amount: "",
  });

  useEffect(() => {
    if (previewData) {
      setFormData({
        status: previewData.STATUS ?? "",
        remarks: previewData.STAFF_REMARKS ?? "",
        amount: previewData.FINAL_AMOUNT ?? "",
      });
      setBankData({
        STUDENT_BANK_ACC: previewData.STUDENT_BANK_ACC || "",
        BANK_IFSC_CODE: previewData.BANK_IFSC_CODE || "",
        STUDENT_BANK_NAME: previewData.STUDENT_BANK_NAME || "",
      });
    }
  }, [previewData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const sol_roll_no = useParams().sol_roll_no;

  const FilePreviewRow = ({ label, fileUrl }) => {
    if (!fileUrl) {
      return (
        <tr>
          <th>{label}</th> <td>{fileUrl}</td>
        </tr>
      );
    }
    const isPdf = fileUrl.toLowerCase().endsWith(".pdf");

    return (
      <tr>
        <th>{label}</th>
        <td colSpan="3">
          {isPdf ? (
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              alt="pdf"
              style={{ textColor: "blue" }}
            >
              View PDF
            </a>
          ) : (
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              <img
                src={fileUrl}
                alt={label}
                width="300"
                style={{
                  cursor: "pointer",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                }}
              />
            </a>
          )}
        </td>
      </tr>
    );
  };
  useEffect(() => {
    const fetchPreviewData = async () => {
      try {
        const response = await api.get(
          `/admin/fetchStudentData/${sol_roll_no}`,
        );

        setPreviewData(response.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPreviewData();
  }, [API_URL]);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      await api.post(
        `/admin/saveFormSubmittedData/${sol_roll_no}`,
        formData,
      );

      toast.success("Response Saved...");

      setTimeout(() => {
        navigate(-1);
      }, 1500);
    } catch (err) {
      toast.error(err.response?.data?.message || "Submission failed");
    } finally {
      setLoading(false);
    }
  };

  const handleBankUpdate = async () => {
    try {
      await api.post(`/admin/updateBankDetails/${sol_roll_no}`, bankData);

      toast.success("Bank details updated successfully");

      setPreviewData((prev) => ({
        ...prev,
        ...bankData,
      }));

      setShowModal(false);
    } catch (err) {
      toast.error("Update failed");
    }
  };

  return (
    <>
      <Helmet title="Preview" /> <FrontendLayout />
      <ToastContainer position="top-center" />
      {loading ? (
        <div className="full-page-loader">
          <ClipLoader size={60} />
        </div>
      ) : (
        <div className="main print-area">
          <div className="only-print-header">
            <Header />
          </div>
          <section className="container-fluid py-4" style={{ width: "95%" }}>
            <div className="card shadow p-4 mb-4">
              <div className="no-print d-flex justify-content-end mb-3">
                <button
                  className="btn btn-success"
                  onClick={() => window.print()}
                >
                  Print Application
                </button>
              </div>
              <div
                className={`card shadow p-4 mb-4 ${
                  previewData.STATUS === "APPROVED"
                    ? "bg-success-subtle border-success"
                    : previewData.STATUS === "VERIFIED"
                    ? "bg-primary-subtle border-primary"
                    : previewData.STATUS === "DISCREPANCY"
                    ? "bg-warning-subtle border-warning"
                    : previewData.STATUS === "REJECTED"
                    ? "bg-danger-subtle border-danger"
                    : "bg-light border-secondary"
                }`}
              >
              <strong>
                {adminStatusMessage[previewData.STATUS] || adminStatusMessage.PENDING}
              </strong>

              {previewData.STAFF_REMARKS && (
                <div className="mt-2">
                  <b>Remarks:</b> {previewData.STAFF_REMARKS}
                </div>
              )}
            </div>
              <div
                className="table-responsive"
                style={{ WebkitOverflowScrolling: "touch" }}
              >
                <table className="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <th className="align-middle">Name</th>
                      <td className="align-middle">
                        {previewData.STUDENT_NAME}
                      </td>
                      <th className="align-middle">SOL Roll No.</th>
                      <td className="align-middle">
                        {previewData.SOL_ROLL_NO}
                      </td>
                      {previewData?.FSS_CODE && (
                        <>
                          <th className="align-middle">FSS Code</th>
                          <td className="align-middle">
                            {previewData.FSS_CODE}
                          </td>
                        </>
                      )}

                      <td className="text-center align-middle">
                        <a
                          href={previewData?.PHOTO}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: "inline-block" }}
                        >
                          <img
                            src={previewData?.PHOTO}
                            alt="Signature"
                            width="80"
                            style={{
                              cursor: "pointer",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                            }}
                          />
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card shadow p-2 p-md-4 mb-4">
              <h5 className="text-center bg-primary text-white py-2 rounded mb-4">
                Personal Details
              </h5>
              <div className="d-flex justify-content-end mb-2">
                <button
                  className="btn btn-warning btn-sm"
                  onClick={() => setShowModal(true)}
                >
                  Edit Bank Details
                </button>

                {showModal && (
                  <div className="modal show fade d-block" tabIndex="-1">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Edit Bank Details</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowModal(false)}
                          ></button>
                        </div>

                        <div className="modal-body">
                          <div className="mb-3">
                            <label className="form-label">Account Number</label>
                            <input
                              type="text"
                              className="form-control"
                              value={bankData.STUDENT_BANK_ACC}
                              onChange={(e) =>
                                setBankData({
                                  ...bankData,
                                  STUDENT_BANK_ACC: e.target.value,
                                })
                              }
                            />
                          </div>

                          <div className="mb-3">
                            <label className="form-label">IFSC Code</label>
                            <input
                              type="text"
                              className="form-control"
                              value={bankData.BANK_IFSC_CODE}
                              onChange={(e) =>
                                setBankData({
                                  ...bankData,
                                  BANK_IFSC_CODE: e.target.value,
                                })
                              }
                            />
                          </div>

                          <div className="mb-3">
                            <label className="form-label">Bank Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={bankData.STUDENT_BANK_NAME}
                              onChange={(e) =>
                                setBankData({
                                  ...bankData,
                                  STUDENT_BANK_NAME: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>

                        <div className="modal-footer">
                          <button
                            className="btn btn-secondary"
                            onClick={() => setShowModal(false)}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary"
                            onClick={handleBankUpdate}
                          >
                            Save Changes
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="table-responsive"
                style={{ WebkitOverflowScrolling: "touch" }}
              >
                <table className="table table-striped table-bordered ">
                  <tbody>
                    <tr>
                      <th>Student's Name</th>
                      <td>{previewData?.STUDENT_NAME || "N/A"}</td>
                      <th>SOL Roll Number</th>
                      <td>{previewData?.SOL_ROLL_NO || "N/A"}</td>
                    </tr>

                    {previewData?.SEMESTER === "I" && (
                      <>
                        <tr>
                          <th>SOL Control Number</th>
                          <td colSpan={3}>{previewData?.PASSWORD || "N/A"}</td>
                        </tr>
                      </>
                    )}

                    <tr>
                      <th>Contact No.</th>
                      <td>{previewData?.MOBILE || "N/A"}</td>
                      <th>Programme</th>
                      <td>{previewData?.COURSE || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Admission Year</th>
                      <td>{previewData?.ADMISSION_YEAR || "N/A"}</td>
                      <th>Current semester</th>
                      <td>{previewData?.SEMESTER || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Aadhaar Number</th>
                      <td>{previewData?.STUDENT_ADHAR_NO || "N/A"}</td>
                      <th>PAN Number</th>
                      <td>{previewData?.STUDENT_PAN_NO || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Bank Holder Name</th>
                      <td>{previewData?.BANK_HOLDER_NAME || "N/A"}</td>
                      <th>Bank Account Number</th>
                      <td>{previewData?.STUDENT_BANK_ACC || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Bank IFSC</th>
                      <td>{previewData?.BANK_IFSC_CODE || "N/A"}</td>
                      <th>Bank Name</th>
                      <td>{previewData?.STUDENT_BANK_NAME || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Father's Name</th>
                      <td>{previewData?.FATHER_NAME || "N/A"}</td>
                      <th>Father's Occupation</th>
                      <td>{previewData?.FATHER_TYPE_OF_JOB || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Father's Annual Income</th>
                      <td>{previewData?.FATHER_ANNUAL_INCOME || "N/A"}</td>
                      <th>Father's PAN</th>
                      <td>{previewData?.FATHER_PAN_NO || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Father's ITR Value</th>
                      <td>{previewData?.FATHER_ITR || "N/A"}</td>
                      <th>Mother's Name</th>
                      <td>{previewData?.MOTHER_NAME || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Mother's Occupation</th>
                      <td>{previewData?.MOTHER_TYPE_OF_JOB || "N/A"}</td>
                      <th>Mother's Annual Income</th>
                      <td>{previewData?.MOTHER_ANNUAL_INCOME || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Mother's PAN</th>
                      <td>{previewData?.MOTHER_PAN_NO || "N/A"}</td>
                      <th>Mother's ITR Value</th>
                      <td>{previewData?.MOTHER_ITR || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Total Annual Family Income</th>
                      <td>{previewData?.TOTAL_FAMILY_INCOME || "N/A"}</td>
                      <th>Total Annual Family Income Lies Between</th>
                      <td>{previewData?.INCOME_LIES_BETWEEN || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>No. of Dependent Family Members</th>
                      <td>{previewData?.DEPENDENT_MEMBER || "N/A"}</td>
                      <th>Income Certificate No</th>
                      <td>{previewData?.INCOME_CERTIFICATE_NO || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Income Certificate Issued By</th>
                      <td>{previewData?.INCOME_ISSUED_BY || "N/A"}</td>
                      <th>Income Certificate Issued Date</th>
                      <td>
                        {new Date(
                          previewData?.INCOME_ISSUE_DATE,
                        ).toLocaleDateString("en-IN")}
                      </td>
                    </tr>
                    {previewData.RATION_CARD_NAME && (
                      <>
                        <tr>
                          <th>Ration Card Name</th>
                          <td>{previewData?.RATION_CARD_NAME || "N/A"}</td>
                          <th>Ration Card Issued By</th>
                          <td>{previewData?.RATION_ISSUED_BY || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>Ration Card Issued Date</th>
                          <td colSpan="3">
                            {previewData?.RATION_ISSUE_DATE
                              ? new Date(
                                previewData.RATION_ISSUE_DATE,
                              ).toLocaleDateString("en-IN")
                              : "N/A"}
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card shadow p-4 mb-4">
              <h5 className="text-center bg-primary text-white py-2 rounded mb-4">
                Upload Details
              </h5>
              <table className="table table-striped table-bordered">
                <tbody>
                  <FilePreviewRow label="Photo" fileUrl={previewData?.PHOTO} />
                  <FilePreviewRow
                    label="Signature"
                    fileUrl={previewData?.SIGNATURE}
                  />
                  <FilePreviewRow
                    label="Latest Fee Receipt"
                    fileUrl={previewData?.FEE_RECEIPT}
                  />
                  <FilePreviewRow
                    label="Family Income Certificate (Issued after 31/03/2026)"
                    fileUrl={previewData?.INCOME_CERTIFICATE}
                  />
                  {previewData?.RATION_CARD && (
                    <FilePreviewRow
                      label="Ration Card"
                      fileUrl={previewData?.RATION_CARD}
                    />
                  )}
                  <FilePreviewRow
                    label="Bank Passbook/Leaf of Cheque"
                    fileUrl={previewData?.BANK_PASSBOOK}
                  />
                  {previewData?.FINAL_YEAR_MARKSHEET && (
                    <FilePreviewRow
                      label="Current Year Marksheet"
                      fileUrl={previewData?.FINAL_YEAR_MARKSHEET}
                    />
                  )}
                  <FilePreviewRow
                    label="Undertaking for Employment Status (Employed / Unemployed / Self-Employed)"
                    fileUrl={previewData?.UNEMPLOYEMENT_DECLARATION}
                  />
                </tbody>
              </table>
            </div>
           
            {((previewData.STATUS === 'VERIFIED' && (adminRole === '1' || adminRole === '3')) || (previewData.STATUS == null && (adminRole === '2' || adminRole === '1'))) && (
              <>
                <div className="card shadow p-4 mb-4">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label htmlFor="status" className="form-label">
                          <b>Status</b>
                        </label>
                        <select
                          className="form-control"
                          name="status"
                          id="status"
                          required
                          value={formData.status}
                          onChange={handleChange}
                        >
                          <option value="">Select</option>

                          {previewData.STATUS === "VERIFIED" ? (
                            <option value="APPROVED">APPROVED</option>
                          ) : previewData.STATUS == null ? (
                            <option value="VERIFIED">VERIFIED</option>
                          ) : null}
                          <option value="DISCREPANCY">DISCREPANCY</option>
                          <option value="REJECTED">REJECTED</option>
                        </select>
                      </div>

                      {formData.status === 'DISCREPANCY' && (
                        <>
                          <div className="col-md-5 mb-3">
                            <label htmlFor="remarks" className="form-label">
                              <b>Remarks</b>
                            </label>
                            <textarea
                              className="form-control"
                              name="remarks"
                              id="remarks"
                              required
                              value={formData.remarks}
                              onChange={handleChange}
                              rows="3"
                            ></textarea>
                          </div>
                        </>
                      )}
                      <div className="row justify-content-center">
                        <button className="btn btn-primary w-50">Save</button>
                      </div>
                    </div>
                  </form>
                </div>
              </>
            )}
          </section>
        </div>
      )}
    </>
  );
}
